import * as React from 'react';

export interface PermissionProps {
  /**
   * The permission object to evaluate against
   */
  permissions: { [x: string]: boolean };
  /**
   * Single value, or comma-separated list of permissions ALL required for the child component to render
   */
  requireAll?: string;
  /**
   * Single value, or comma-separated list of permissions where at least ONE required for the child component to render
   */
  requireAny?: string;
  /**
   * Returns the value inside a <li> instead of <div>
   */
  isListElement?: boolean;
  children?: React.ReactNode;
}
/**
 * Prevents child components from rendering if required permissions are not present
 */
export class Permission extends React.PureComponent<PermissionProps, any>{

  public render() {

    if (!this.props.permissions){
      return null;
    }

    if (!!this.props.requireAll &&
      this.props.requireAll.split(',').reduce((memo, p) => memo || !this.props.permissions[p], false)) {
      return null;
    }

    if (!!this.props.requireAny &&
      this.props.requireAny.split(',').reduce((memo, p) => memo && !this.props.permissions[p], true)) {
      return null;
    }

    return this.props.isListElement ?
      <li>{this.props.children}</li>
      : <div>{this.props.children}</div>;
  }
}
